import type { ImageLoaderProps } from 'next/image';

interface DirectusImageProps {
  fit?: 'cover' | 'contain' | 'inside' | 'outside';
  preset?: string;
}

const BACKEND_BASE_URL = process.env.NEXT_PUBLIC_BACKEND_BASE_URL ?? '';

const isImageFromDirectus = (src: string) => {
  return !!BACKEND_BASE_URL && src.startsWith(BACKEND_BASE_URL);
};

export default function directusImageLoader({
  src,
  width,
  quality,
  fit,
  preset
}: ImageLoaderProps & DirectusImageProps) {
  if (!isImageFromDirectus(src)) {
    return `${src}?width=${width}`;
  }

  const url = new URL(src);
  if (!!preset) {
    url.searchParams.set('key', preset);
    return url.href;
  }
  const w = Math.min(width || 0, 1920);
  url.searchParams.set('fit', fit || 'inside');
  url.searchParams.set('width', w > 0 ? w.toString() : '1920');
  url.searchParams.set('quality', quality?.toString() || '95');
  url.searchParams.set('withoutEnlargement', 'true');
  url.searchParams.set('format', 'webp');
  return url.href;
}
